import { colors, themeColors } from "@hubrise/react-components"
import styled, { css } from "styled-components"

export const StyledOptionList = styled.div<{ isValid: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${({ isValid }) =>
    isValid
      ? ""
      : css`
          outline: 2px solid ${themeColors.danger};
          outline-offset: 0.5rem;
        `}
`

export const Title = styled.div`
  white-space: nowrap;
  font-weight: 500;
`

export const Selection = styled.div<{ isValid: boolean }>`
  ${({ isValid }) =>
    isValid
      ? ""
      : css`
          color: ${themeColors.danger};
        `}
`

export const Options = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 1rem;
  align-items: start;
`

export const OptionLabel = styled.label`
  display: flex;
  align-items: baseline;
`

export const OptionInput = styled.input`
  accent-color: ${colors.textDark};
  position: relative;
  top: 0.1rem;
`

export const NameAndPrice = styled.span<{ isActive: boolean }>`
  padding: 0 0.5rem;
  line-height: 1.3;
  cursor: pointer;

  ${({ isActive }) =>
    isActive &&
    css`
      font-weight: 500;
    `}
`

export const Name = styled.span``

export const Price = styled.span`
  margin-left: 0.5rem;
  white-space: nowrap;
`
